import Settings from 'core/Settings';
class PreloadState extends Phaser.State {

	init() {
		this.handleScaling();
		this.checkSettings();
		this.drawPreloader();
	}

	/**
	 * Resizes the stage if we're on mobile
	 */
	handleScaling() {
		if(this.game.device.desktop) {
				// nothing to do, for now
		} else {
			this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
			this.game.scale.forceOrientation(true, false);
			this.game.scale.enterIncorrectOrientation.add(this.handleIncorrect);
			this.game.scale.leaveIncorrectOrientation.add(this.handleCorrect);
			this.game.stage.disableVisibilityChange = false;
			this.scale.setShowAll();
			this.scale.refresh();
			if (this.game.scale.width / this.game.scale.height < window.innerWidth / window.innerHeight) {
				var canvas = document.querySelector('canvas');
				canvas.style.position = 'absolute';
				canvas.style.top = "0";
			}
		}
	}

	handleIncorrect() {
		document.getElementById("turn").style.display="block";
	}

	handleCorrect() {
		document.getElementById("turn").style.display="none";
	}

	/**
	 * Pulls in any prpeviously saved settings.
	 */
	checkSettings() {
		if(Settings.loadSetting("music") == "false") {
			Settings.MUSIC_VOLUME = 0;
		}

		if(Settings.loadSetting("sfx") == "false") {
			Settings.SFX_VOLUME = 0;
		}
	}

	/**
	 * Draws the preload bar
	 */
	drawPreloader() {
		this.loaderBase = this.game.add.graphics(100,185);
    this.loaderBase.beginFill(0x5b2033);
		this.loaderBase.drawRect(0, 0, 600, 30);

		this.loaderFill = this.game.add.graphics(110,195);
    this.loaderFill.beginFill(0xFFFFFF);
		this.loaderFill.drawRect(0, 0, 580, 10);
		this.loaderFill.scale.x = 0;
	}

	/**
	 * Actually load the items in.
	 */
	preload() {
		this.game.load.image('backText', 'assets/cover/back.png');
		this.game.load.image('preloader-bg', 'assets/ui/preloader.png');
		this.game.load.image('menu-bg', 'assets/cover/base.jpg');
		this.game.load.image('game-bg', 'assets/ui/game.png');
		this.game.load.image('settings-bg', 'assets/settings/base.jpg');

		this.game.load.image('play-button', 'assets/cover/play.png');
		this.game.load.image('settings-button', 'assets/cover/settings.png');
		this.game.load.image('title-text', 'assets/cover/text.png');
		this.game.load.image('back-button', 'assets/ui/back-button.png');

		this.game.load.image('gameover-bg', 'assets/gameover/base.jpg');
		this.game.load.image('gameover-home', 'assets/gameover/home.png');
		this.game.load.image('gameover-play-again', 'assets/gameover/play-again.png');
		this.game.load.image('gameover-popup', 'assets/gameover/popup.png');
		this.game.load.image('gameover-text', 'assets/gameover/text.png');

		this.game.load.image('toggleOn', 'assets/ui/toggleOn.png');
		this.game.load.image('toggleOff', 'assets/ui/toggleOff.png');

		this.game.load.image('bar', 'assets/ui/bar.png');


		this.game.load.image('game-background', 'assets/game/game-background.jpg');
		this.game.load.image('game-background-grass', 'assets/game/game-background2.jpg');
		this.game.load.image('sticky', 'assets/game/sticky.png');



		/*
		this.game.load.image('game-foreground', 'assets/game/roof.png');
		this.game.load.image('platform1', 'assets/game/platform1.png');
		this.game.load.image('platform2', 'assets/game/platform2.png');
		this.game.load.image('platform3', 'assets/game/platform3.png');
		this.game.load.image('platform4', 'assets/game/platform4.png');
		this.game.load.image('platform5', 'assets/game/platform5.png');
		this.game.load.image('platform6', 'assets/game/platform6.png');*
		this.game.load.image('long-platform1', 'assets/game/long-platform1.png');
		this.game.load.image('long-platform2', 'assets/game/long-platform2.png');

		this.game.load.image('monster1', 'assets/game/monster1.png');
		this.game.load.image('monster2', 'assets/game/monster2.png');
		this.game.load.image('monster3', 'assets/game/monster3.png');

		this.game.load.image('foreground1', 'assets/game/foreground1.png');
		this.game.load.image('foreground2', 'assets/game/foreground2.png');
		this.game.load.image('foreground3', 'assets/game/foreground3.png');
		this.game.load.image('foreground4', 'assets/game/foreground4.png');
		this.game.load.image('sparkle', 'assets/game/sparkle.png');

		this.game.load.image('lolly1', 'assets/game/lolly1.png');
		this.game.load.image('lolly2', 'assets/game/lolly2.png');
		this.game.load.image('lolly3', 'assets/game/lolly3.png');
		this.game.load.image('lolly4', 'assets/game/lolly4.png');

		this.game.load.image('projectile1', 'assets/game/projectiles/projectile1.png');
		this.game.load.image('projectile2', 'assets/game/projectiles/projectile2.png');
		this.game.load.image('projectile3', 'assets/game/projectiles/projectile3.png');
		this.game.load.image('projectile4', 'assets/game/projectiles/projectile4.png');
		this.game.load.image('projectile1anim', 'assets/game/projectiles/projectile1anim.png');
		this.game.load.image('explosion', 'assets/game/explosion.png');
		for(var i = 1; i <= 11; i++) {
			this.game.load.image('pickup'+i, 'assets/game/pickups/pickup'+i+'.png');
		}



		*/
		this.game.load.spritesheet('player', 'assets/game/runcycle.png', 137, 177, 4);
		this.game.load.spritesheet('fastone', 'assets/game/fastruncycle.png', 300, 300, 3);

		this.game.load.image('warning', 'assets/ui/warning.png');





		this.game.load.audio('music', 'sound/music.mp3');
		this.game.load.audio('jump', 'sound/jump.mp3');
		this.game.load.audio('pickup', 'sound/pickup.mp3');
		this.game.load.audio('ow', 'sound/ow.mp3');
		this.game.load.audio('alarm', 'sound/alarm.mp3');
		this.game.load.audio('whoosh', 'sound/whoosh.mp3');

		this.game.load.atlas('atlas', 'assets/game/atlas/atlas.png', 'assets/game/atlas/atlas.json');
	}

  loadUpdate() {
		this.loaderFill.scale.x = this.game.load.progress / 100;
  }

	// Loading complete! Go to the menu.
  create() {
    this.state.start('MenuState');
	}
}

export default PreloadState;
